import apiClient from '@/shared/api/client';
import { ApiResponse } from '@/shared/api/types';

export interface TeamMember {
  id: string;
  userId: string;
  practiceId: string;
  role: string;
  createdAt: string;
  user: {
    id: string;
    email: string;
    firstName?: string;
    lastName?: string;
    lastLoginAt?: string;
    isActive: boolean;
  };
}

export const teamApi = {
  getMembers: async (): Promise<ApiResponse<TeamMember[]>> => {
    const response = await apiClient.get<ApiResponse<TeamMember[]>>('/team');
    return response.data;
  },

  inviteMember: async (data: { email: string; role: string }): Promise<ApiResponse<TeamMember>> => {
    const response = await apiClient.post<ApiResponse<TeamMember>>('/team/invite', data);
    return response.data;
  },

  updateMember: async (id: string, data: Partial<TeamMember>): Promise<ApiResponse<TeamMember>> => {
    const response = await apiClient.put<ApiResponse<TeamMember>>(`/team/${id}`, data);
    return response.data;
  },

  updateRole: async (id: string, role: string): Promise<ApiResponse<TeamMember>> => {
    const response = await apiClient.put<ApiResponse<TeamMember>>(`/team/${id}/role`, { role });
    return response.data;
  },

  removeMember: async (id: string): Promise<void> => {
    await apiClient.delete(`/team/${id}`);
  },
};
